import { sanityWebsiteClient } from './sanityWebsiteClient';

interface ARFiles {
	iosUrl: string;
	androidUrl: string;
}

// TODO: Move AR files to Storyblok
export function getArFiles(): Promise<ARFiles> {
	return sanityWebsiteClient.fetch(
		`*[_type == "arAssets"] {
            "iosUrl": iosFile.asset->url,
            "androidUrl": androidFile.asset->url,
        }[0]`
	);
}
